import './App.css';
import React, { useState } from 'react';
import FlashcardsApp from './FlashcardsApp';
import PassiveLearningApp from './PassiveLearningApp';
import MultipleChoiceApp from './MultipleChoiceApp';
import wordList7_5 from './wordList7-5';
import wordList7_6 from './wordList7-6';
import wordList8_1 from './wordList8-1';
import wordList8_2 from './wordList8-2';

const now = new Date();
const day = String(now.getDate()).padStart(2, '0');
const month = String(now.getMonth() + 1).padStart(2, '0');
const year = now.getFullYear();
const BUILD_DATE = `${day}.${month}.${year}`;

const CHAPTERS = {
  '7-5': { id: '7-5', name: 'Rozdział 7-5', words: wordList7_5, icon: '📘' },
  '7-6': { id: '7-6', name: 'Rozdział 7-6', words: wordList7_6, icon: '🍽️' },
  '8-1': { id: '8-1', name: 'Rozdział 8-1', words: wordList8_1, icon: '🚗' },
  '8-2': { id: '8-2', name: 'Rozdział 8-2', words: wordList8_2, icon: '🏡' },
};

const MODES = {
  passive: { id: 'passive', name: 'Ucz się', icon: '👀', Component: PassiveLearningApp },
  choice: { id: 'choice', name: 'Test wyboru', icon: '📝', Component: MultipleChoiceApp },
  active: { id: 'active', name: 'Sprawdź się', icon: '✅', Component: FlashcardsApp },
};

const INITIAL_SELECTION = {
  chapter: null,
  mode: null,
};

function App() {
  const [selection, setSelection] = useState(INITIAL_SELECTION);

  const handleBack = () => {
    setSelection(INITIAL_SELECTION);
  };

  // Now there's only one declaration of handleChapterSelect
  const handleChapterSelect = (chapterId) => {
    setSelection(prev => ({ ...prev, chapter: chapterId }));
  };

  const handleModeSelect = (modeId) => {
    setSelection(prev => ({ ...prev, mode: modeId }));
  };

  const { chapter, mode } = selection;
  const selectedChapter = chapter ? CHAPTERS[chapter] : null;
  const selectedMode = mode ? MODES[mode] : null;

  const versionFooter = (
    <div style={{
      position: 'fixed', bottom: '5px', right: '5px', color: 'white', fontSize: '10px', zIndex: 9999, pointerEvents: 'none', opacity: 0.8
    }}>
      v. {BUILD_DATE}
    </div>
  );

  if (!selectedChapter || !selectedMode) {
    return (
      <div className="start-screen">
        <h1>Wybierz rozdział i sposób nauki</h1>
        <div className="mode-description">
          <p><span className="mode-icon">👀</span><strong>Ucz się:</strong> Kliknij, aby odkryć tłumaczenie — do nauki i powtórki.</p>
          <p><span className="mode-icon">📝</span><strong>Test wyboru:</strong> Wybierz poprawną odpowiedź z trzech opcji.</p>
          <p><span className="mode-icon">✅</span><strong>Sprawdź się:</strong> Wpisz po niemiecku — sprawdź, ile pamiętasz.</p>
        </div>

        <div className="selection-grid">
          <div className="selection-column">
            {Object.values(CHAPTERS).map(ch => (
              <button key={ch.id} onClick={() => handleChapterSelect(ch.id)} className={chapter === ch.id ? 'selected' : ''}>{ch.icon} {ch.name}</button>
            ))}
          </div>
          <div className="selection-column">
            {Object.values(MODES).map(m => (
              <button key={m.id} onClick={() => handleModeSelect(m.id)} disabled={!chapter} className={mode === m.id ? 'selected' : ''}>{m.icon} {m.name}</button>
            ))}
          </div>
        </div>
        {versionFooter}
      </div>
    );
  }

 const { Component, words } = { Component: selectedMode.Component, words: selectedChapter.words };
  return (
    <>
      <Component words={words} onBack={handleBack} />
      {versionFooter}
    </>
  );
}

export default App;
